import styled from 'styled-components';
import COLORS from 'constants/colors';

const InstructionBox = styled.div`
  border: 1px solid ${COLORS.GRAY.GRAY_400};
  border-radius: 4px;
  padding: 11px;
  margin-bottom: 24px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export default InstructionBox;
